import { createAction, props } from '@ngrx/store'

export const SOURCE = '[Expiration Date Filter]'

export const resetEffectiveType = createAction(
    `${SOURCE} ResetEffectiveType`,
)

export const setEffectiveType = createAction(
    `${SOURCE} SetEffectiveType`, props<{ effectiveType: any }>()
)

export const resetExistencyDate = createAction(
    `${SOURCE} ResetExistencyDate`,
)

export const setExistencyDate = createAction(
    `${SOURCE} SetExistencyDate`, props<{ existencyDate: any }>()
)

export const resetExistencyIntervalFrom = createAction(
    `${SOURCE} ResetExistencyIntervalFrom`,
)

export const setExistencyIntervalFrom = createAction(
    `${SOURCE} SetExistencyIntervalFrom`, props<{ existencyIntervalFrom: any }>()
)

export const resetExistencyIntervalTo = createAction(
    `${SOURCE} ResetExistencyIntervalTo`,
)

export const setExistencyIntervalTo = createAction(
    `${SOURCE} SetExistencyIntervalTo`, props<{ existencyIntervalTo: any }>()
)
